import { render, staticRenderFns } from "./MapWrapper.vue?vue&type=template&id=2537a4b9&"
import script from "./MapWrapper.vue?vue&type=script&lang=js&"
export * from "./MapWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MapWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports